/**
 * 公告
 */
 import React, { useEffect, useState } from "react"
 import { LoadStatus } from "../../load_status"
 import stock_info from "../../../../modules/stock_info/newweb"
 import { quotedata } from "../../quotedata"

export function StockNotice(props: { quotedata: quotedata }) {
  const [stockNotice, setStockNotice] = useState([])
  const [currentPageStockNotice, setCurrentPageStockNotice] = useState([])
  const [loading, setLoading] = useState(false)
  const [pageNumber, setPageNumber] = useState(1)
  const [totalNotice, setTotalNotice] = useState(0)

  const openDetail = (infoId: string) => {
    location.href = "https://np-info.eastmoney.com/wap/notice/?infocode=" + infoId
  }
  const loadMore = () => {
    setPageNumber(pageNumber+1)
  }

  const getStockNotice = () => {
    const CHOICE_ZS = 47
    let market = props.quotedata.market
    let code = props.quotedata.code
    const isBK = props.quotedata.market == 90

    setLoading(true)
    if (isBK) {
      //板块特殊处理
      code = props.quotedata.code.substring(2).replace(/\b(0+)/ig,"")
    }
    if (props.quotedata.market == CHOICE_ZS) {
      code = "000001"
      market = 1
    }

    stock_info.getStockNotices_new(code,market, pageNumber, 20, isBK).then((back: any) => {
      if (back.list && back.list.length) {
        if (pageNumber == 1) {
          setStockNotice(back.list)
        } else {
          let temp = stockNotice.concat(back.list)
          setStockNotice(temp)
        }
        setTotalNotice(back.total_hits)
        setCurrentPageStockNotice(back.list)
        setLoading(false)
      }else{
        setCurrentPageStockNotice([])
        setLoading(false)
       }
    })
  }

  useEffect(() => {
    getStockNotice()
  }, [pageNumber])

  return (
    <>
      <ul className="report-list">
          {stockNotice.length > 0 && stockNotice.map((item: any) => {
            return (
              <li key={item.art_code}>
                <a>
                  <div className="tit" onClick={() => openDetail(item.art_code)}>
                    {
                      (props.quotedata.market == 105 || props.quotedata.market == 106 || props.quotedata.market == 107)? <span>{item.title_ch || item.title}</span>: <span>{item.title}</span>
                    }
                    {/* {item.title} */}
                  </div>
                  <p className="time">{item.notice_date.substring(0, 10)}</p>
                </a>
              </li>
            )
          })}
        </ul>
      {loading && <LoadStatus icon={true} title="数据加载中..." className="com_tips" />}
      {!loading && totalNotice == 0 && stockNotice.length == 0 && <LoadStatus icon={false} title="暂无数据" className="com_tips" />}
      {stockNotice.length > 0 && stockNotice.length == totalNotice && <LoadStatus icon={false} title="到底了" className="com_tips" />}
      {currentPageStockNotice.length == 20 && stockNotice.length < totalNotice && (
        <div
          className="comm-more"
          onClick={(e) => {
            e.preventDefault()
            loadMore()
          }}
        >
          <a href="#">加载更多</a>
        </div>
      )}
    </>
  )
}
